import React from 'react';
import PropTypes from 'prop-types';

import Picture from '../../Util/Picture/Picture';

// import assets
import './stageModule.scss';

const StageModuleView = (props) => {
  const HeadlineTag = `h${props.priority}`;
  return (
    <div className="m-article-module">
      <div className={'m-stage-module'}>
        <div className={'m-stage-module__upper'}>
          <Picture
            class={'m-stage-module__image'}
            src={{
              sm: props.src['1020'],
              md: props.src['1020'],
              lg: props.src['1600'],
              xl: props.src['1900'],
              xxl: props.src['2560'],
              xxxl: props.src['2560'],
              default: props.src.default,
            }}
            imageCollection={[props]}
            alt={props.alt}
            disableZoom
          />
          <div className={'m-stage-module__overlay'}>
            <div className={'m-stage-module__overlay-inner'}>
              <span className={`m-stage-module__overline ${(props.blackFont ? 'm-stage-module__overline--black' : '')}`}>
                {props.overline}
              </span>
              <HeadlineTag className={`m-stage-module__headline ${(props.blackFont ? 'm-stage-module__headline--black' : '')}`}>
                {props.headline}
              </HeadlineTag>
            </div>
          </div>
        </div>
        <div className={'m-stage-module__img-desc'} dangerouslySetInnerHTML={{ __html: props.desc }} />
      </div>
    </div>
  );
};

StageModuleView.propTypes = {
  src: PropTypes.shape(),
  alt: PropTypes.string,
  overline: PropTypes.string,
  headline: PropTypes.string,
  desc: PropTypes.string,
  blackFont: PropTypes.bool,
  priority: PropTypes.string,
};

StageModuleView.defaultProps = {
  src: {
    sm: '',
    md: '',
    lg: '',
    xl: '',
    xxl: '',
    default: '',
  },
  alt: '',
  overline: '',
  headline: '',
  desc: '',
  blackFont: false,
  priority: '2',
};

export default StageModuleView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/StageModule/StageModuleView.jsx